<div *ngIf="(comparators$ | async)!.length > 0" class="page_container">
    <table class="listing_table">
        <thead class="header_stiky">
            <tr class="head_table">
                <th>{{"import.file_name"| translate}}</th>
                <th>{{"common.total_products"| translate}}</th>
                <th>{{"common.date_time"| translate}}</th>
                <th>{{"import.file_dowload"| translate}}</th>
            </tr>
        </thead>
        <tbody class="scrollable-body">
            <ng-container *ngFor="let comparator of comparators$ | async; let i = index">
                <tr class="body_table hover_tr cursor">
                    <td (click)="details(comparator.id, comparator.validated)">
                        <span class="bold_span">{{comparator.file_name}}</span>
                    </td>
                    <td (click)="details(comparator.id, comparator.validated)" class="td_block cursor">
                        <span class="bold_span">{{comparator.nbr_products}}</span>
                    </td>
                    <td class="td_block">
                        <span class="bold_span ng-star-inserted">{{comparator.date | adaptToUserUtcOffset | date: DATE_FORMAT }}</span><br/>
                    </td>
                    <td>
                        <button class="td_block" (click)="downloadFile(comparator)">
                            <img class="listing_image files" src="assets/icones/xls.svg" alt=""><br />
                            <span class="descr_elemnt bold_span" style="text-align: center;">
                                {{ '.Xls' }}
                            </span>
                        </button>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>
<div *ngIf="(comparators$ | async)!.length === 0  && !(isAppLoading$ | async)" class="no_reseult">
    <img src="../../../../../assets/icones/no-comparators.svg" alt="">
    <h3>{{"comparator.no_comparators" | translate}}</h3>
    <button class="save_btn_pop_up blue_btn" (click)="importComparators()">
        <span>{{"import.import" | translate | uppercase}}</span>
        <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
    </button>
</div>
